<form [formGroup]="form" class="children_quota_table">
  <div class="row justify-content-center">
    <div class="table-responsive">
      <table
        class="table quote-table"
        aria-describedby="tableToInputChilsQuotas"
      >
        <thead>
          <th id="frist">&nbsp;</th>
          <th id="age">
            Age
            <select
              style="border-color: transparent"
              formControlName="ageUnit"
              (change)="selectAgeUnit()"
            >
              <option value="311">year</option>
              <option value="312">month</option>
            </select>
          </th>
          <th id="gender">Gender</th>
          <th id="clickCompletes">
            {{ data.clickBalance ? 'CLICKS' : 'COMPLETES' }}
          </th>
          <th id="min" class="min-max-width">
            <span>MIN</span>
          </th>
          <th id="max" class="min-max-width">
            <span>MAX</span>
          </th>
        </thead>
        <tbody
          *ngIf="data.qualification.data.length"
          formArrayName="quotas"
          class="add-input-fields"
        >
          <tr
            [hidden]="!hasHaveChildrenCtr"
            *ngFor="let quotaForm of quotas.controls; let i = index"
            [formGroupName]="i"
          >
            <label [hidden]="i === quotas.controls.length - 1"
              >Have Children</label
            >
            <td [hidden]="i === quotas.controls.length - 1">
              <fieldset class="age-range-inputs" [disabled]="i !== 0">
                <input
                  type="number"
                  class="form-control border-0 border-bottom text-center rounded-0"
                  maxlength="2"
                  formControlName="min"
                  psUiInputRestriction="[0-9]"
                  [ngClass]="{ 'input-not-allowed': i !== 0 }"
                />
                <span> to </span>
                <input
                  type="number"
                  class="form-control border-0 border-bottom text-center rounded-0 mx-2"
                  maxlength="2"
                  formControlName="max"
                  psUiInputRestriction="[0-9]"
                  [ngClass]="{ 'input-not-allowed': i !== 0 }"
                />
              </fieldset>
            </td>
            <td
              class="table-gender"
              [hidden]="i === quotas.controls.length - 1"
              *ngIf="i !== quotas.controls.length - 1"
            >
              <fieldset class="radio" [disabled]="i !== 0">
                <label
                  [ngClass]="{
                    'table-gender-boy-selected':
                      quotas.controls[i].value.gender === '111',
                    'table-gender-boy': !(
                      quotas.controls[i].value.gender === '111'
                    )
                  }"
                  ><strong>Boy</strong
                  ><input
                    hidden
                    type="radio"
                    value="111"
                    formControlName="gender"
                /></label>
                <label
                  [ngClass]="{
                    'table-gender-girl-selected':
                      quotas.controls[i].value.gender === '112',
                    'table-gender-girl': !(
                      quotas.controls[i].value.gender === '112'
                    )
                  }"
                  ><strong>Girl</strong
                  ><input
                    hidden
                    type="radio"
                    value="112"
                    formControlName="gender"
                /></label>
                <label
                  [ngClass]="{
                    'table-gender-either-selected':
                      quotas.controls[i].value.gender === 'both',
                    'table-gender-either': !(
                      quotas.controls[i].value.gender === 'both'
                    )
                  }"
                  ><strong>Either</strong
                  ><input
                    hidden
                    type="radio"
                    value="both"
                    formControlName="gender"
                /></label>
              </fieldset>
            </td>
            <td [hidden]="i === quotas.controls.length - 1">
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0"
                formControlName="number"
                (keyup)="numberChange($event, i)"
                psUiInputRestriction="[0-9]"
              />
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0 mx-2"
                maxlength="3"
                formControlName="percentage"
                (keyup)="percentageChange($event, i)"
                psUiInputRestriction="[0-9]"
              />
              <span>%</span>
            </td>
            <td [hidden]="i === quotas.controls.length - 1">
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0"
                formControlName="minimum"
                [attr.readonly]="true"
                psUiInputRestriction="[0-9]"
              />
            </td>
            <td [hidden]="i === quotas.controls.length - 1">
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0"
                maxlength="3"
                formControlName="maximum"
                [attr.readonly]="true"
                psUiInputRestriction="[0-9]"
              />
            </td>
            <td [hidden]="i === quotas.controls.length - 1">
              <a *ngIf="i === 0" class="link-primary" (click)="addQuotaRow()">
                <em class="fa fa-plus"></em> Click to Add
              </a>
              <a *ngIf="i > 0" class="link-primary" (click)="deleteQuotaRow(i)">
                <em class="fa fa-times"></em>
              </a>
            </td>
          </tr>

          <tr
            [hidden]="!hasNoChildrenCtr"
            [formGroupName]="quotas.controls.length - 1"
          >
            <label>No Children</label>
            <td></td>
            <td></td>
            <td>
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0"
                formControlName="number"
                (keyup)="numberChange($event, quotas.controls.length - 1)"
                psUiInputRestriction="[0-9]"
              />
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0 mx-2"
                maxlength="3"
                formControlName="percentage"
                (keyup)="percentageChange($event, quotas.controls.length - 1)"
                psUiInputRestriction="[0-9]"
              />
              <span>%</span>
            </td>
            <td>
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0"
                formControlName="minimum"
                [attr.readonly]="true"
                psUiInputRestriction="[0-9]"
              />
            </td>
            <td>
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0"
                maxlength="3"
                formControlName="maximum"
                [attr.readonly]="true"
                psUiInputRestriction="[0-9]"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</form>
